import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: { width: 'fit-content' },
    backArrow: {
        height: '30px',
        width: '30px'
    },
    breadcrumbContainer: { paddingLeft: '.5rem' },
    singleLink: { paddingLeft: '.5rem' },
    anchorText: {
        fontSize: '22px',
        fontWeight: 'bold' as 'bold',
        textTransform: 'uppercase' as 'uppercase',
        lineHeight: '30px',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073'
    },
    link: { textDecorationLine: 'none' as 'none' }
}));